<script async setup lang="ts">
import type { IAccoItem } from '@/composables/Interfaces/apiInterfaces'
import AccoItemRating from '../AccosFilterPage/FilterResults/AccoItem/SubComponent/AccoItemRating.vue'
import CartAccoItemDelete from '../Cart/SubComponent/CartAccoItemDelete.vue'
import { computed } from 'vue'

const props = defineProps<{
  item: IAccoItem
  direct: boolean
}>()

const direct = computed(() => props.direct)
</script>

<template>
  <div class="relative w-full hover:text-inherit hover:no-underline md:basis-[48%]">
    <div class="ui-company-card pui-accocart-card flex h-full min-h-32 flex-row overflow-hidden !rounded shadow-md md:border md:shadow-none">
      <div class="relative w-2/5">
        <div class="h-full overflow-hidden">
          <img class="aspect-video h-full w-full object-cover" :alt="props.item.companyName" :src="props.item.img" />
        </div>
      </div>
      <div class="relative w-3/5 items-center gap-1 p-4 leading-5">
        <AccoItemRating :is-superior="props.item.isSuperior" :rating="props.item.rating" :symbol-class="props.item.symbolClass" />
        <div class="mb-0 text-[1.08rem] font-bold">{{ props.item.companyName }}</div>
        <div class="mt-1 text-sm font-normal">{{ props.item.location }}</div>
      </div>
    </div>
    <div class="absolute right-1 top-1">
      <CartAccoItemDelete v-if="!direct" :cid="props.item.companyId" />
    </div>
  </div>
</template>
